var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner--container",class:[_vm.backgroundColor],style:([_vm.getBackgroundColor()])},[_c('div',{staticClass:"banner--body"},[_vm._t("default")],2),_c('div',{staticClass:"banner--figure",class:[_vm.backgroundPosition]},[_c('img',{attrs:{"src":_vm.backgroundFigure,"alt":_vm.backgroundFigureAlt}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }